<template>
  <div>
    <div slot="title">
      <h2> Reportes / Envíos </h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 .abc">
            <nav class="row">
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" data-toggle="tab" href="#nav-envios" role="tab" aria-controls="nav-home" aria-selected="true" v-on:click="TabChange">Envios</a>
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-consulta-documentos" role="tab" aria-controls="nav-profile" aria-selected="false" v-on:click="TabChange">Consultas de Documentos</a>
                <a class="nav-item nav-link" data-toggle="tab" href="#nav-digitalizacion" role="tab" aria-controls="nav-contact" aria-selected="false" v-on:click="TabChange">Digitalización</a>
              </div>
            </nav>
            <div class="tab-content row mt-2" id="nav-tabContent">
              <div class="tab-pane fade show active" id="nav-envios" role="tabpanel" aria-labelledby="nav-home-tab">
                <form class="d-flex flex-wrap">
                  <div class="col-8 area">
                    <div class="row">
                      <div class="form-group col-6">
                        <label for="exampleInputEmail1">Fecha Inicial</label>
                        <input type="date" class="form-control" id="fechaInicialE" v-model="FechaIE">
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleInputPassword1">Fecha Final</label>
                        <input type="date" class="form-control" id="fechaFinalE" v-model="FechaFE">
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Tipo de Documento</label>
                        <TiposDocumentoEnvio :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :parametros="parametros_TipoDocumento.parametros" v-on:valorParaElPadre="cambioDeTipoDeDocumento" :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" :key="parametros_TipoDocumento.key"></TiposDocumentoEnvio>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Áreas</label>
                        <AreasPromocion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioAreaPromocion" :idDelInput="'areaSeleccionada1'" :parametros="parametros_AreaPromocion.parametros" :valorDefinido="parametros_AreaPromocion.areaPromoId" :key="parametros_AreaPromocion.key" :idOrden="parametros_AreaPromocion.OrdenamientoPromo"></AreasPromocion>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Usuarios Recepción</label>
                        <UsuariosEquitas :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeUsuarioE" :idDelInput="'usuarioEquitasEnvios'" :valorDefinido="parametros_UsuarioEquitas.TipoId" :key="parametros_UsuarioEquitas.key"></UsuariosEquitas>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Usuarios Digitalización</label>
                        <UsuariosDigitalizacon :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeUsuarioD" :idDelInput="'usuarioDigitalizacionEnvios1'" :valorDefinido="parametros_UsuarioDigitalzacion.TipoId" :key="parametros_UsuarioDigitalzacion.key"></UsuariosDigitalizacon>
                      </div>
                    </div>
                    <div class="row" style="display:inline-block;">
                      <button type="button" class="btn btn-outline-light" v-on:click="ImprimirTabla()"><i class="fas fa-print"></i> Imprimir Tabla</button>
                      <button type="button" class="btn btn-outline-light" @click="GetFolios"><i class="fas fa-search"></i> Buscar Registros</button>
                      <button type="button" class="btn btn-outline-light" v-on:click="LimpiarFiltros()"><i class="fas fa-broom"></i> Limpiar Filtros</button>
                      <label id="numRegE" style="margin:10px;font-weight:bold"></label>
                    </div>
                    <br><br>
                    <div class="row justify-content-between" id="div_OpcionesEnvio" style="visibility: hidden">
                      <button type="button" class="btn btn-outline-light" @click="EnviarDocumentos"><i class="fas fa-paper-plane"></i> Enviar</button>
                      <input id="envTodo" type="checkbox" v-model="EnviarTodo" @change="UnCheckSolamente">
                      <label for="envTodo">Enviar Todo</label>
                      <input id="envSelec" type="checkbox" v-model="EnviarSeleccionados" @change="UnCheckSolamente">
                      <label for="envSelec">Enviar Seleccionados</label>
                      <input id="envDigital" type="checkbox" v-model="EnviarDigitalizados" @change="UnCheckSolamente">
                      <label for="envDigital">Enviar Digitalizados</label>
                      <input id="envSinDigital" type="checkbox" v-model="EnviarSinDigitalizar" @change="UnCheckSolamente">
                      <label for="envSinDigital">Enviar sin Digitalizar</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group col-lg-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="pendEnvio" v-model="PendientesEnvio" @change="UnCheckSolamente">
                        <label class="form-check-label" for="pendEnvio">
                          Pendientes de Envío
                        </label>
                      </div>
                    </div>
                    <div class="form-group col-lg-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="docEnviados" v-model="DocumentosEnviados" @change="UnCheckSolamente">
                        <label class="form-check-label" for="docEnviados">
                          Documentos Enviados
                        </label>
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <div class="form-check">
                        <input class="form-check-input" id="rangoTiempo" type="checkbox" v-model="RangoDeTiempo">
                        <label class="form-check-label" for="rangoTiempo">
                          Rango de Tiempo
                        </label>
                      </div>
                    </div>
                    <div v-if="RangoDeTiempo" class="row mt-2">
                      <div class="form-group col-6 mb-0">
                        <input type="time" class="form-control" id="InicioRangoE">
                      </div>
                      <div class="form-group col-6 mb-0">
                        <input type="time" class="form-control" id="FinRangoE">
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <div class="form-check">
                        <input class="form-check-input" id="horaDigital" type="checkbox" v-model="HoraDeDigitalizacion">
                        <label class="form-check-label" for="horaDigital">
                          Hora de Digitalización
                        </label>
                      </div>
                    </div>
                    <div v-if="HoraDeDigitalizacion" class="row mt-2">
                      <div class="form-group col-6 mb-0">
                        <input type="time" class="form-control" id="InicioDigE">
                      </div>
                      <div class="form-group col-6 mb-0">
                        <input type="time" class="form-control" id="FinDigE">
                      </div>
                    </div>
                    <div>
                      <div class="form-group col-lg-12">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="demandaCivCont" v-model="DemCivCont">
                          <label class="form-check-label" for="demandaCivCont">
                            Excluir Demandas Civiles y Contencioso
                          </label>
                        </div>
                      </div>
                      <div class="form-group col-lg-12">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="promoSala" v-model="PromSala">
                          <label class="form-check-label" for="promoSala">
                            Excluir Promociones Sala Administrativa [Contencioso]
                          </label>
                        </div>
                      </div>
                      <div class="form-group col-lg-12">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="excCivCont" v-model="excluirCivCont">
                          <label class="form-check-label" for="excCivCont">
                            Excluir Civiles y Mercantiles
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <br>
                <div class="col-12 table-responsive">
                  <table 
                  class="table table-light table-hover" 
                  id="tablaEnvios"
                  data-search="true"
                  data-toggle="table"
                  data-pagination="true">
                    <thead class="thead-dark">
                      <tr>
                        <th data-checkbox="true" data-sortable="true">CHK</th>
                        <th data-field="Area" data-sortable="true">Área</th>
                        <th data-field="TipoDoc" data-sortable="true">Tipo Documento</th>
                        <th data-field="Actor" data-sortable="true">Actor</th>
                        <th data-field="Demandado" data-sortable="true">Demandado</th>
                        <th data-field="UsuarioRecepcion" data-sortable="true">Usuario Oficialia</th>
                        <th data-field="UsuarioDigitalizacion" data-sortable="true">Usuario Digitalización</th>
                        <th data-field="FechaRegistro" data-sortable="true">Fecha Registro</th>
                        <th data-field="FechaDigitalizacion" data-sortable="true">Fecha Digitalización</th>
                        <th data-field="DescJuicio" data-sortable="true">Juicio</th>
                        <th data-field="IdEqui" data-sortable="true">Folio</th>
                        <th data-field="SubTipoDocumento" data-sortable="true">Sub Tipo Documento</th>
                        <th data-field="NumeroDocumento" data-sortable="true"># Documento</th>
                        <th data-field="Sintesis" data-sortable="true">Síntesis</th>
                        <th data-field="DocumentoRelacion" data-sortable="true">Doc Rel</th>
                        <th data-field="Monto" data-sortable="true">Monto</th>
                        <th data-field="NumeroEnvio" data-sortable="true"># Envío</th>
                      </tr>
                    </thead>
                      <tbody>
                      </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane fade" id="nav-consulta-documentos" role="tabpanel" aria-labelledby="nav-profile-tab">
                <form class="d-flex flex-wrap">
                  <div class="col-8 area">
                    <div class="row">
                      <div class="form-group col-4">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="docRecibidos" v-model="DocsRecibidos" @change="UnCheckSolamente">
                          <label class="form-check-label" for="docRecibidos">
                            Por Documentos Recibidos
                          </label>
                        </div>
                      </div>
                      <div class="form-group col-4">
                        <div class="form-check">
                          <input class="form-check-input" type="checkbox" value="" id="docEnviados2" v-model="DocumentosEnviados" @change="UnCheckSolamente">
                          <label class="form-check-label" for="docEnviados2">
                            Por Documentos Enviados
                          </label>
                        </div>
                      </div>
                      <div class="form-group col-4">
                        <div class="form-check">
                          <input class="form-check-input" id="numEnvio" type="checkbox" v-model="NumeroEnvio" @change="UnCheckSolamente">
                          <label class="form-check-label" for="numEnvio">
                            Por Número de Envío
                          </label>
                          <div v-if="NumeroEnvio" class="row mt-2">
                            <div class=" col-6 mb-0">
                              <input type="text" id="envioBusqueda" v-model="numEnvConsultas">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleInputEmail1">Fecha Inicial</label>
                        <input type="date" class="form-control" id="fechaInicialC" v-model="FechaIC">
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleInputPassword1">Fecha Final</label>
                        <input type="date" class="form-control" id="fechaFinalC" v-model="FechaFC">
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Tipo de Documento</label>
                        <TiposDocumentoEnvio :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :parametros="parametros_TipoDocumento.parametros" v-on:valorParaElPadre="cambioDeTipoDeDocumento" :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" :key="parametros_TipoDocumento.key"></TiposDocumentoEnvio>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect2">Áreas</label>
                        <AreasPromocion :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioAreaPromocion" :idDelInput="'areaSeleccionada2'" :parametros="parametros_AreaPromocion.parametros" :valorDefinido="parametros_AreaPromocion.areaPromoId" :key="parametros_AreaPromocion.key"></AreasPromocion>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Usuarios Recepción</label>
                        <UsuariosEquitas :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeUsuarioE" :idDelInput="'usuarioEquitasCons'" :valorDefinido="parametros_UsuarioEquitas.TipoId" :key="parametros_UsuarioEquitas.key"></UsuariosEquitas>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Usuarios Digitalización</label>
                        <UsuariosDigitalizacon :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeUsuarioD" :idDelInput="'usuarioDigitalizacionCons'" :valorDefinido="parametros_UsuarioDigitalzacion.TipoId" :key="parametros_UsuarioDigitalzacion.key"></UsuariosDigitalizacon>
                      </div>
                    </div>
                    <div class="row" style="display:inline-block;">
                      <button type="button" class="btn btn-outline-light" v-on:click="ImprimirTabla()"><i class="fas fa-print"></i> Imprimir Tabla</button>
                      <button type="button" class="btn btn-outline-light" @click="GetFolios"><i class="fas fa-search"></i> Buscar Registros</button>
                      <button type="button" class="btn btn-outline-light" v-on:click="LimpiarFiltros()"><i class="fas fa-broom"></i> Limpiar Filtros</button>
                      <label id="numRegC" style="margin:10px;font-weight:bold"></label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="form-group col-12">
                      <div class="form-check">
                        <input class="form-check-input" id="rangoTiempoCon" type="checkbox" v-model="RangoDeTiempoCons">
                        <label class="form-check-label" for="checkbox">
                          Rango de Tiempo
                        </label>
                      </div>
                      <div v-if="RangoDeTiempoCons" class="row mt-2">
                        <div class="form-group col-6 mb-0">
                          <input type="time" class="form-control" id="InicioRangoC">
                        </div>
                        <div class="form-group col-6 mb-0">
                          <input type="time" class="form-control" id="FinRangoC">
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="horaDigCon" v-model="HoraDeDigitalizacionCons">
                        <label class="form-check-label">
                          Hora de Digitalización
                        </label>
                      </div>
                      <div v-if="HoraDeDigitalizacionCons" class="row mt-2">
                        <div class="form-group col-6 mb-0">
                          <input type="time" class="form-control" id="InicioDigC">
                        </div>
                        <div class="form-group col-6 mb-0">
                          <input type="time" class="form-control" id="FinDigC">
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-lg-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="excDemCivContCon" v-model="excluirCivContCons">
                        <label class="form-check-label" for="defaultCheck1">
                          Excluir Demandas Civiles y Contencioso
                        </label>
                      </div>
                    </div>
                    <div class="form-group col-lg-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="excSalaCon" v-model="excluirSalaCons">
                        <label class="form-check-label" for="defaultCheck1">
                          Excluir Promociones Sala Administrativa [Contencioso]
                        </label>
                      </div>
                    </div>
                    <div class="form-group col-lg-12">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="excCivMerCons" v-model="excluirCivMerCons">
                        <label class="form-check-label" for="defaultCheck1">
                          Excluir Civiles y Mercantiles
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
                <br>
                <div class="col-12 table-responsive">
                  <table 
                  class="table table-light table-hover" 
                  id="tablaConsultas"
                  data-search="true"
                  data-toggle="table"
                  data-pagination="true">
                    <thead>
                      <tr>
                        <th data-checkbox="true" data-sortable="true">CHK</th>
                        <th data-field="Area" data-sortable="true">Área</th>
                        <th data-field="TipDoc" data-sortable="true">Tipo Documento</th>
                        <th data-field="Actor" data-sortable="true">Actor</th>
                        <th data-field="Demandado" data-sortable="true">Demandado</th>
                        <th data-field="UsuarioRecepcion" data-sortable="true">Usuario Oficialia</th>
                        <th data-field="UsuarioDigitalizacion" data-sortable="true">Usuario Digitalización</th>
                        <th data-field="FechaRegistro" data-sortable="true">Fecha Registro</th>
                        <th data-field="FechaDigitalizacion" data-sortable="true">Fecha Digitalización</th>
                        <th data-field="DescJuicio" data-sortable="true">Juicio</th>
                        <th data-field="IdEqui" data-sortable="true">Folio</th>
                        <th data-field="SubTipoDocumento" data-sortable="true">Sub Tipo Documento</th>
                        <th data-field="NumeroDocumento" data-sortable="true"># Documento</th>
                        <th data-field="Sintesis" data-sortable="true">Síntesis</th>
                        <th data-field="DocumentoRelacion" data-sortable="true">Doc Rel</th>
                        <th data-field="Monto" data-sortable="true">Monto</th>
                        <th data-field="NumeroEnvio" data-sortable="true"># Envío</th>
                      </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane fade w-100" id="nav-digitalizacion" role="tabpanel" aria-labelledby="nav-contact-tab">
                <form class="d-flex flex-wrap">
                  <div class="col-8 area">
                    <div class="row">
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Tipo de Documento</label>
                        <TiposDocumentoEnvio :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :parametros="parametros_TipoDocumento.parametros" v-on:valorParaElPadre="cambioDeTipoDeDocumento" :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" :key="parametros_TipoDocumento.key"></TiposDocumentoEnvio>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleFormControlSelect1">Usuario Digitalización</label>
                        <UsuariosDigitalizacon :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeUsuarioD" :idDelInput="'usuarioDigitalizacionEnvios2'" :valorDefinido="parametros_UsuarioDigitalzacion.TipoId" :key="parametros_UsuarioDigitalzacion.key"></UsuariosDigitalizacon>
                      </div>
                      <div class="form-group col-6">
                        <label for="exampleInputPassword1">Fecha de Digitalización</label>
                        <input type="date" class="form-control" id="fechaFinalD" v-model="FechaFD">
                      </div>
                      <div class="col-6">
                      <div class="form-group col-12">
                      <div class="form-check">
                        <input class="form-check-input" id="horaDigitalDig" type="checkbox" v-model="HoraDeDigitalizacionDig">
                        <label class="form-check-label" for="checkbox">
                          Hora de Digitalizacion
                        </label>
                      </div>
                      <div v-if="HoraDeDigitalizacionDig" class="row mt-2">
                        <div class="form-group col-6 mb-0">
                          <input type="time" class="form-control" id="InicioDigD">
                        </div>
                        <div class="form-group col-6 mb-0">
                          <input type="time" class="form-control" id="FinDigD">
                        </div>
                      </div>
                      </div>
                    </div>
                    </div>
                    <div class="form-group mb-0 mt-4">
                    </div>
                    <div class="row" style="display:inline-block;">
                      <button type="button" class="btn btn-outline-light" v-on:click="ImprimirTabla()"><i class="fas fa-print"></i> Imprimir Tabla</button>
                      <button type="button" class="btn btn-outline-light" @click="GetFolios"><i class="fas fa-search"></i> Buscar Registros</button>
                      <button type="button" class="btn btn-outline-light" v-on:click="LimpiarFiltros()"><i class="fas fa-broom"></i> Limpiar Filtros</button>
                      <label id="numRegD" style="margin:10px;font-weight:bold"></label>
                    </div>
                  </div>
                </form>
                <br>
                <div class="col-12 table-responsive">
                  <table 
                  class="table table-light table-hover" 
                  id="tablaDigitalizacion"
                  data-search="true"
                  data-toggle="table"
                  data-pagination="true">
                    <thead>
                      <tr>
                        <th data-checkbox="true" data-sortable="true">CHK</th>
                        <th data-field="Area" data-sortable="true">Área</th>
                        <th data-field="TipDoc" data-sortable="true">Tipo Documento</th>
                        <th data-field="Actor" data-sortable="true">Actor</th>
                        <th data-field="Demandado" data-sortable="true">Demandado</th>
                        <th data-field="UsuarioRecepcion" data-sortable="true">Usuario Oficialia</th>
                        <th data-field="UsuarioDigitalizacion" data-sortable="true">Usuario Digitalización</th>
                        <th data-field="FechaRegistro" data-sortable="true">Fecha Registro</th>
                        <th data-field="FechaDigitalizacion" data-sortable="true">Fecha Digitalización</th>
                        <th data-field="DescJuicio" data-sortable="true">Juicio</th>
                        <th data-field="IdEqui" data-sortable="true">Folio</th>
                        <th data-field="SubTipoDocumento" data-sortable="true">Sub Tipo Documento</th>
                        <th data-field="NumeroDocumento" data-sortable="true"># Documento</th>
                        <th data-field="Sintesis" data-sortable="true">Síntesis</th>
                        <th data-field="DocumentoRelacion" data-sortable="true">Doc Rel</th>
                        <th data-field="Monto" data-sortable="true">Monto</th>
                        <th data-field="NumeroEnvio" data-sortable="true"># Envío</th>
                      </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane fade w-100" id="nav-mensajeros" role="tabpanel" aria-labelledby="nav-contact-tab">
                <form class="row">
                  <div class="col-4">
                    <div class="area">
                      <h3>FILTRAR BÚSQUEDA</h3>
                      <div class="form-group-h">
                        <div class="form-check">
                          <input class="form-check-input" id="filtroZona" type="checkbox" v-model="porNombreZona" @change="UnCheckSolamente">
                          <label class="form-check-label" for="filtroZona">
                            Por Zona
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" id="filtroEnvio" type="checkbox" v-model="porEnvioZona" @change="UnCheckSolamente">
                          <label class="form-check-label" for="filtroEnvio">
                            Por Envío
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="form-check-input" id="filtroTiempo" type="checkbox" v-model="porTiempoZona" @change="UnCheckSolamente">
                          <label class="form-check-label" for="filtroTiempo">
                            Por Tiempo
                          </label>
                        </div>
                      </div>
                      <div class="w-100">
                        <div v-if="porNombreZona" class="form-group">
                          <label for="exampleFormControlSelect1">Zona</label>
                          <ZonasCiviles :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" v-on:valorParaElPadre="cambioDeZona" :idDelInput="'zonaCvil'" :valorDefinido="parametros_ZonaCivil.TipoId" :key="parametros_ZonaCivil.key"></ZonasCiviles>
                        </div>
                        <div v-if="porEnvioZona" class="form-group">
                          <label for="exampleFormControlSelect1">Envio</label>
                          <input type="text" v-model="numEnvConsultas">
                        </div>
                        <div v-if="porTiempoZona" class="form-group">
                          <label for="exampleInputPassword1">Fecha Inicio (La fecha final será la del día de hoy)</label>
                          <input type="date" class="form-control" id="fechaInicialM" v-model="FechaIM">
                        </div>
                      </div>
                      <div class="form-group mb-0 mt-4">
                      </div>
                    </div>
                  </div>
                  <br>
                  <div class="col-12 table-responsive">
                  <table 
                  class="table table-light table-hover" 
                  id="tablaMensajeros"
                  data-search="true"
                  data-toggle="table"
                  data-pagination="true">
                      <thead>
                        <tr>
                          <th data-sortable="true">Número de Envío</th>
                          <th data-sortable="true">Zona del Envío</th>
                          <th data-sortable="true">Número de Documentos</th>
                          <th data-sortable="true">Área a la que se envía</th>
                        </tr>
                      </thead>
                      <tbody>
                      </tbody>
                    </table>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/components/TemisCivil/Comun/Plantilla.vue';
  import enumeraciones from '@/../static/js/enumeraciones';
  import catalogos from '@/../static/js/catalogos';
  import comun from '@/../static/js/comun';
  import api from '@/../static/js/api';
  import axios from 'axios';

  export default {
    data() {
      return {
        parametros_AreaPromocion:{
          key: "",
          areaPromoId: -1,
          OrdenamientoPromo: 1,
          parametros: {}
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {}
        },
        parametros_UsuarioEquitas:{
          key: "",
          TipoId: -1,
          parametros: {}
        },
        parametros_UsuarioDigitalzacion:{
          key: "",
          TipoId: -1,
          parametros: {}
        },
        parametros_ZonaCivil:{
          key: "",
          TipoId: -1,
          parametros: {}
        },
        enumeraciones,
        RangoDeTiempo: false,
        HoraDeDigitalizacion: false,
        DemCivCont: false,
        PromSala: false,
        excluirCivCont: false,
        DocsRecibidos: false,
        DocumentosEnviados: false,
        PendientesEnvio: true,
        NumeroEnvio: false,
        RangoDeTiempoCons: false,
        HoraDeDigitalizacionCons: false,
        excluirCivMerCons: false,
        excluirCivContCons: false,
        excluirSalaCons: false,
        promoSalaCons: false,
        HoraDeDigitalizacionDig: false,
        porNombreZona: false,
        porEnvioZona: false,
        porTiempoZona: false,
        Folios: [],
        IdEquis: [],
        tab: 1,
        IdUsuarioE: 0,
        IdUsuarioD: 0,
        HoraIni: '',
        HoraFin: '',
        FechaIni:'',
        FechaFin:'',
        NombreZona:'',
        TipoDoc: 0,
        numEnvConsultas: 0,
        TabAnterior:0,
        Seleccionados:[],
        prefijoBusqueda:'te',
        sinDgitalizar: false,
        EnviarTodo: true,
        EnviarSeleccionados: false,
        EnviarDigitalizados: false,
        EnviarSinDigitalizar: false,
        ConArchivoDigital:[],
        SinArchivoDigital:[],
        Digitalizados: false,
        Tabla_aOrdenar:'tablaEnvios',
        AreaAsignada: -1,
        FechaIE:moment().format('YYYY-MM-DD'),
        FechaFE:moment().format('YYYY-MM-DD'),
        FechaIC:moment().format('YYYY-MM-DD'),
        FechaFC:moment().format('YYYY-MM-DD'),
        FechaFD:moment().format('YYYY-MM-DD'),
        FechaIM:moment().format('YYYY-MM-DD')
      }
    },
    components: {
      TiposDocumentoEnvio: catalogos.TemisCivil.TiposDocumentoEnvio,
      AreasPromocion: catalogos.TemisCivil.AreasPromocion,
      UsuariosDigitalizacon: catalogos.TemisCivil.UsuariosDigitalizacion,
      UsuariosEquitas: catalogos.TemisCivil.UsuariosEquitas,
      ZonasCiviles: catalogos.TemisCivil.ZonasCiviles,
      Layout
    },
    methods: {
      GetDatos() {
        //axios.Post('http://')
      },
      LimpiarFiltros(datos){
        this.RangoDeTiempo = false;
        this.HoraDeDigitalizacion = false;
        this.DemCivCont = false;
        this.PromSala = false;
        this.excluirCivCont = false;
        this.DocsRecibidos = false;
        this.DocumentosEnviados = false;
        this.PendientesEnvio = true;
        this.NumeroEnvio = false;
        this.RangoDeTiempoCons = false;
        this.HoraDeDigitalizacionCons = false;
        this.excluirCivMerCons = false;
        this.excluirCivContCons = false;
        this.excluirSalaCons = false;
        this.promoSalaCons = false;
        this.HoraDeDigitalizacionDig = false;
        this.porNombreZona = false;
        this.porEnvioZona = false;
        this.porTiempoZona = false;
        this.IdUsuarioE = 0;
        this.IdUsuarioD = 0;
        this.HoraIni = '';
        this.HoraFin = '';
        this.FechaIni ='';
        this.FechaFin ='';
        this.NombreZona ='';
        this.TipoDoc = 0;
        this.numEnvConsultas = 0;
        this.TabAnterior = 0;
        this.prefijoBusqueda ='te';
        this.sinDgitalizar = false;
        this.EnviarTodo = true;
        this.EnviarSeleccionados = false;
        this.EnviarDigitalizados = false;
        this.EnviarSinDigitalizar = false;
        this.Digitalizados = false;
        this.Tabla_aOrdenar ='tablaEnvios';
        this.AreaAsignada = -1;
        this.ReestablecerControles(this.tab);
      },
      cambioAreaPromocion(datos){
        var d = new Date();
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_AreaPromocion.areaPromoId = parseInt(id);
        this.AreaFiltro = this.parametros_AreaPromocion.areaPromoId;
        this.$emit("cambioAreaPromocion",datos);
      },
      cambioDeUsuarioE(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_UsuarioEquitas.TipoId = parseInt(id);
        this.IdUsuarioE = this.parametros_UsuarioEquitas.TipoId;
      },
      cambioDeUsuarioD(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_UsuarioDigitalzacion.TipoId = parseInt(id);
        this.IdUsuarioD = this.parametros_UsuarioDigitalzacion.TipoId;
      },
      cambioDeTipoDeDocumento(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(id);
        this.TipoDoc = this.parametros_TipoDocumento.tipoDocumentoId;
        this.$emit('cambioDeTipoDeDocumento',datos);
      },
      cambioDeZona(datos){
        var id = 0;
        if(isNaN(datos))
          id = parseInt(datos.target.value);
        else
          id = parseInt(datos);
        this.parametros_ZonaCivil.TipoId = parseInt(id);
        this.NombreZona = datos.target.options[this.parametros_ZonaCivil.TipoId].innerHTML;
        this.$emit('cambioDeZona',datos);
      },
      ObtenerHoraInicial_Final(){
        if(this.tab == 1)
        {
          this.HoraIni = this.RangoDeTiempo ? document.getElementbById('InicioRangoE').value : (this.HoraDeDigitalizacion ? document.getElementById('InicioDigE').value : '');
          this.HoraFin = this.RangoDeTiempo ? document.getElementbById('FinRangoE').value : (this.HoraDeDigitalizacion ? document.getElementById('FinDigE').value : '');
        }
        else if(this.tab == 2)
        {
          this.HoraIni = this.RangoDeTiempoCons ? document.getElementbById('InicioRangoC').value : (this.HoraDeDigitalizacionCons ? document.getElementById('InicioDigC').value : '');
          this.HoraFin = this.RangoDeTiempoCons ? document.getElementbById('FinRangoC').value : (this.HoraDeDigitalizacionCons ? document.getElementById('FinDigC').value : '');
        }
        else if(this.tab == 3)
        {
          this.HoraIni = this.HoraDeDigitalizacionDig ? document.getElementById('InicioDigD').value : '';
          this.HoraFin = this.HoraDeDigitalizacionDig ? document.getElementById('FinDigD').value : '';
        }
      },
      ObtenerFechaInicial_Final(){
        if(this.tab == 1)
        {
          this.FechaIni = document.getElementById('fechaInicialE').value;
          this.FechaFin = document.getElementById('fechaFinalE').value;
        }
        else if(this.tab == 2)
        {
          this.FechaIni = document.getElementById('fechaInicialC').value;
          this.FechaFin = document.getElementById('fechaFinalC').value;
        }
        else if(this.tab == 3)
        {
          this.FechaFin = document.getElementById('fechaFinalD').value;
        }
        else if(this.tab == 4)
        {
          this.FechaIni = document.getElementById('fechaInicialM').value;
        }
      },
      UnCheckSolamente: function(e){
        //Consultas de Documentos
        if(e.currentTarget.id == 'docRecibidos' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('docEnviados2').checked = false;
          document.getElementById('numEnvio').checked = false;
          this.NumeroEnvio = 0;
          this.DocumentosEnviados = false;
          }
        if(e.currentTarget.id == 'docEnviados2' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('docRecibidos').checked = false;
          document.getElementById('numEnvio').checked = false;
          this.NumeroEnvio = 0;
          this.DocsRecibidos = false;
          }
        if(e.currentTarget.id == 'numEnvio' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('docRecibidos').checked = false;
          document.getElementById('docEnviados2').checked = false;
          this.DocsRecibidos = false;
          this.DocumentosEnviados = false;
          }
        if(e.currentTarget.id == 'pendEnvio' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('docEnviados').checked = false;
          this.DocumentosEnviados = false;
          }
        if(e.currentTarget.id == 'docEnviados' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('pendEnvio').checked = false;
          this.PendientesEnvio = false;
          }
          //Mensajeros
        if(e.currentTarget.id == 'filtroZona' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('filtroEnvio').checked = false;
          document.getElementById('filtroTiempo').checked = false;
          this.porEnvioZona = false;
          this.porTiempoZona = false;
          }
        if(e.currentTarget.id == 'filtroEnvio' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('filtroZona').checked = false;
          document.getElementById('filtroTiempo').checked = false;
          this.porNombreZona = false;
          this.porTiempoZona = false;
          }
        if(e.currentTarget.id == 'filtroTiempo' && document.getElementById(e.currentTarget.id).checked){
          document.getElementById('filtroZona').checked = false;
          document.getElementById('filtroEnvio').checked = false;
          this.porNombreZona = false;
          this.porEnvioZona = false;
          }
          //Envíos
          if(e.currentTarget.id == 'envTodo' && document.getElementById(e.currentTarget.id).checked){
            document.getElementById('envSelec').checked = false;
            document.getElementById('envDigital').checked = false;
            document.getElementById('envSinDigital').checked = false;
            this.EnviarSeleccionados = false;
            this.EnviarDigitalizados = false;
            this.EnviarSinDigitalizar = false;
          }
          if(e.currentTarget.id == 'envSelec' && document.getElementById(e.currentTarget.id).checked){
            document.getElementById('envTodo').checked = false;
            document.getElementById('envDigital').checked = false;
            document.getElementById('envSinDigital').checked = false;
            this.EnviarTodo = false;
            this.EnviarDigitalizados = false;
            this.EnviarSinDigitalizar = false;
          }
          if(e.currentTarget.id == 'envDigital' && document.getElementById(e.currentTarget.id).checked){
            document.getElementById('envTodo').checked = false;
            document.getElementById('envSelec').checked = false;
            document.getElementById('envSinDigital').checked = false;
            this.EnviarTodo = false;
            this.EnviarSeleccionados = false;
            this.EnviarSinDigitalizar = false;
          }
          if(e.currentTarget.id == 'envSinDigital' && document.getElementById(e.currentTarget.id).checked){
            document.getElementById('envTodo').checked = false;
            document.getElementById('envSelec').checked = false;
            document.getElementById('envDigital').checked = false;
            this.EnviarTodo = false;
            this.EnviarSeleccionados = false;
            this.EnviarDigitalizados = false;
          }
      },
      ColoresDistintos(elemento){
        var idTabla = '';
        if(this.tab == 1)
        {
          idTabla = 'tablaEnvios';
        }
        if(this.tab == 2)
        {
          idTabla = 'tablaConsultas';
        }
        if(this.tab == 3)
        {
          idTabla = 'tablaDigitalizacion';
        }
        if(this.tab == 4)
        {
          idTabla = 'tablaMensajeros';
        }
        var tabla = document.getElementById(idTabla).getElementsByTagName('tbody')[0];
        var nuevaFila = tabla.insertRow();
        if(elemento.UsuarioDigitalizacion === "SIN DIGITALIZAR")
        {
          this.sinDgitalizar = true;
          nuevaFila.style = "background:#d95030;font: 9px Verdana, sans-serif;";
        }else
        {
          nuevaFila.style = "background:#9b9b9b;font: 9px Verdana, sans-serif;";
        }
        nuevaFila.insertCell().innerHTML = "<input type=\"checkbox\" id=\"" + tabla.rows.length + this.prefijoBusqueda + "\" />";
        Object.entries(elemento).forEach(valor=>nuevaFila.insertCell().appendChild(document.createTextNode(valor[1])));
      },
      LimpiarTablas(){
        var tablas_aVaciar = [];
        if(this.tab == 1){
          tablas_aVaciar = ['tablaEnvios'];
        }
        if(this.tab == 2){
          tablas_aVaciar = ['tablaConsultas'];
        }
        if(this.tab == 3){
          tablas_aVaciar = ['tablaDigitalizacion'];
        }
        if(this.tab == 4){
          tablas_aVaciar = ['tablaMensajeros'];
        }
        //Tablas
        for (var i = 0, len = tablas_aVaciar.length; i < len; i++)
        {
          var tableRef = document.getElementById(tablas_aVaciar[i]);
          while ( tableRef.rows.length > 1 )
          {
            tableRef.deleteRow(1);
          }
        }
      },
      ObtenerFechaDTP(){
        let fecha = new Date();
        let fechaFormato = Intl.DateTimeFormat("az").format(fecha);

        return fechaFormato;
      },
      ReestablecerControles(numeroTab){
        let d = new Date();
        let hoyFormatoDT = this.ObtenerFechaDTP();
        if(numeroTab == 1)
        {
          if(this.HoraDeDigitalizacion)
          {
            document.getElementById('FinDigE').value = '';
            document.getElementById('InicioDigE').value = '';
            this.HoraDeDigitalizacion = false;
          }
          if(this.RangoDeTiempo)
          {
            document.getElementById('FinRangoE').value = '';
            document.getElementById('InicioRangoE').value = '';
            this.RangoDeTiempo = false;
          }
          this.DocumentosEnviados = false;
          this.FechaIE = hoyFormatoDT;
          this.FechaFE = hoyFormatoDT;
          // document.getElementById('fechaFinalE').value = hoyFormatoDT;
          // document.getElementById('fechaInicialE').value = hoyFormatoDT;
        }
        if(numeroTab == 2)
        {
          if(this.HoraDeDigitalizacionCons)
          {
            document.getElementById('FinDigC').value = '';
            document.getElementById('InicioDigC').value = '';
            this.HoraDeDigitalizacionCons = false;
          }
          if(this.RangoDeTiempoCons)
          {
            document.getElementById('FinRangoC').value = '';
            document.getElementById('InicioRangoC').value = '';
            this.RangoDeTiempoCons = false;
          }
          this.numEnvConsultas = 0;
          // document.getElementById('fechaFinalC').value = hoyFormatoDT;
          // document.getElementById('fechaInicialC').value = hoyFormatoDT;
          this.FechaIC = hoyFormatoDT;
          this.FechaFC = hoyFormatoDT;
          document.getElementById('numEnvio').checked = false;
          document.getElementById('docRecibidos').checked = false;
          document.getElementById('docEnviados2').checked = false;
        }
        if(numeroTab == 3)
        {
          this.excluirSalaCons = false;
          this.excluirCivMerCons = false;
          this.excluirCivContCons = false;
          if(this.HoraDeDigitalizacionDig)
          {
            document.getElementById('FinDigD').value = '';
            document.getElementById('InicioDigD').value = '';
            this.HoraDeDigitalizacionDig = false;
          }
          document.getElementById('fechaFinalD').value = '';
          this.parametros_AreaPromocion.key = "Area_Flush_" + d.getMilliseconds();
          this.parametros_TipoDocumento.key = "TipDoc_Flush_" + d.getMilliseconds();
          this.parametros_UsuarioEquitas.key = "UsrEqui_Flush_" + d.getMilliseconds();
          this.parametros_UsuarioDigitalzacion.key = "UsrDig_Flush_" + d.getMilliseconds();     
        }
        if(numeroTab == 4)
        {
          if(this.porTiempoZona)
          {
            // document.getElementById('fechaInicialM').value = hoyFormatoDT;
            this.FechaIM = hoyFormatoDT;
            this.porTiempoZona = false;
          }
          if(this.porNombreZona)
          {
            this.parametros_ZonaCivil.key = "Zona_Flush_" + d.getMilliseconds();
            this.porNombreZona = false;
          }
          if(this.porEnvioZona)
          {
            this.numEnvConsultas = 0;
            this.porEnvioZona = false;
          }
        }
      },
      TabChange: function (event){
        this.Digitalizados = false;
        this.Folios = [];
        this.TabAnterior = this.tab;
        let activa = event.target.outerText;
        if(activa == 'Envios'){
          this.tab = 1;
          this.prefijoBusqueda = 'te';
          this.Tabla_aOrdenar = 'tablaEnvios';
          this.LimpiarTablas();
        }
        if(activa == 'Consultas de Documentos'){
          this.tab = 2;
          this.prefijoBusqueda = 'tc';
          this.Tabla_aOrdenar = 'tablaConsultas';
          this.LimpiarTablas();
        }
        if(activa == 'Digitalización'){
          this.tab = 3;
          this.prefijoBusqueda = 'td';
          this.Digitalizados = true;
          this.Tabla_aOrdenar = 'tablaDigitalizacion';
          this.LimpiarTablas();
        }
        if(activa == 'Mensajeros'){
          this.tab = 4;
          this.prefijoBusqueda = 'tm';
          this.Tabla_aOrdenar = 'tablaMensajeros';
          this.LimpiarTablas();
        }
        this.ReestablecerControles(this.TabAnterior);
        document.getElementById('div_OpcionesEnvio').style.visibility = 'hidden';
      },
      ObtenerElementosFiltrados(selec,digital,sindigital,sinFiltros){
        var idTabla = '';
        this.Seleccionados = [];
        if(this.tab == 1)
          idTabla = 'tablaEnvios';
        if(this.tab == 2)
          idTabla = 'tablaConsultas';
        if(this.tab == 3)
          idTabla = 'tablaDigitalizacion';
        if(this.tab == 4)
          idTabla = 'tablaMensajeros';
        var filasTabla = document.getElementById(idTabla).rows;
        var chunches = [];
        if(selec)
          chunches = $('#' + idTabla).find('input[type="checkbox"]:checked');
        else
          chunches = filasTabla;
        for(var i = 0; i < chunches.length; i++)
        {
          if(sinFiltros)
          {
            this.Seleccionados.push(filasTabla[i].cells[10].innerText);
          }
          else
          {
            if(selec)
            {
              var indice = parseInt(chunches[i].id.replace(this.prefijoBusqueda,''));
              this.Seleccionados.push(filasTabla[indice].cells[10].innerText);
            }else if(digital && filasTabla[i].cells[6].innerText != "SIN DIGITALIZAR")
            {
              this.ConArchivoDigital.push(filasTabla[i].cells[10].innerText);
            }else if(sindigital && filasTabla[i].cells[6].innerText == "SIN DIGITALIZAR")
            {
              this.SinArchivoDigital.push(filasTabla[i].cells[10].innerText);
            }
          }
        }
      },
      ImprimirTabla(){
        if(this.Folios.length > 0)
        {
        let peticion = {
              EsPrueba:false,
              Folios:this.Folios,
              PorTipoDoc:this.TipoDoc > 0 ? false : true
        }
        axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.ImprimeTabla, peticion,{responseType: 'blob'})
            .then(respuesta => {
              if (respuesta.data.SiHayError) {
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);                
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
              } else {
                if (respuesta.data.Satisfactorio != "") {
                  const pdfWindow = window.open(URL.createObjectURL(new Blob([respuesta.data], {type: 'application/pdf'})), '_blank').print();
                }
              }
            })
            .catch(excepcion => {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })
        }else
        {
          comun.mensajeDeAlerta("NO HAY REGISTROS PARA IMPRIMIR", null, null)
        }
      },
      LlenarTablaBS() {
        var $tabla_aLlenar = null;
        if(this.tab == 1)
          $tabla_aLlenar = $("#tablaEnvios");
        if(this.tab == 2)
          $tabla_aLlenar = $("#tablConsultas");
        if(this.tab == 3)
          $tabla_aLlenar = $("#tablaDigitalizacion");
        $tabla_aLlenar.bootstrapTable({data: this.Folios});
        $tabla_aLlenar.bootstrapTable("load",this.Folios);
      },
      EnviarDocumentos(){
        let continuarEnvio = true;
        comun.SeEstaCargandoInformacion(true);
        if(this.EnviarSeleccionados)
        {
          this.ObtenerElementosFiltrados(true,false,false,false);
          if(this.Seleccionados.length > 0)
            this.IdEquis = this.Seleccionados;
          else
          {
            comun.mensajeDeAlerta("No hay documentos seleccionados para envío", null, null);
            comun.SeEstaCargandoInformacion(false);
            continuarEnvio = false;
          }
        }
        if(this.EnviarDigitalizados)
        {
          this.ObtenerElementosFiltrados(false,true,false,false);
          if(this.ConArchivoDigital.length > 0)
            this.IdEquis = this.ConArchivoDigital;
          else
          {
            comun.mensajeDeAlerta("No hay documentos digitalizados para envío", null, null);
            comun.SeEstaCargandoInformacion(false);
            continuarEnvio = false;
          }
        }
        if(this.EnviarSinDigitalizar)
        {
          this.ObtenerElementosFiltrados(false,false,true,false);
          if(this.SinArchivoDigital.length > 0)
            this.IdEquis = this.SinArchivoDigital;
          else
          {
            comun.mensajeDeAlerta("No hay documentos sin digitalizar para envío", null, null);
            comun.SeEstaCargandoInformacion(false);
            continuarEnvio = false;
          }
        }
        if(this.EnviarTodo)
        {
          this.ObtenerElementosFiltrados(false,false,false,true);
          if(this.Seleccionados.length > 0)
            this.IdEquis = this.Seleccionados;
          else
          {
            comun.mensajeDeAlerta("No hay documentos seleccionados para envío", null, null);
            comun.SeEstaCargandoInformacion(false);
            continuarEnvio = false;
          }
        }
        if(continuarEnvio)
        {
          if((this.Seleccionados.length <= 0) && (this.SinArchivoDigital.length <= 0) && (this.ConArchivoDigital.length <= 0 || this.ConArchivoDigital[0] == "Folio"))
          {
            comun.SeEstaCargandoInformacion(false);
            comun.mensajeDeAlerta("Ningún folio cumple con los criterios del envío", null, null);
          }else{
          let peticion = {
              Folios_aEnviar:this.IdEquis
            }
          axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.EnviarDocumentos, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
              .then(respuesta => {
                if (respuesta.data.SiHayError) {
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                } else {
                  if (respuesta.data.Satisfactorio != "") {
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta("Número de énvío: " + respuesta.data.NumeroEnvio, null, null);
                    this.Folios = [];
                    this.IdEquis = [];
                    const OBTENER_STREAM = `${api.conexion}${api.TemisCivil.sistema.Oficialia.ReporteEnviados}?NumeroEnvio=${respuesta.data.NumeroEnvio}`;
                    axios.get(OBTENER_STREAM, { responseType: 'blob' })
                          .then(respuesta => {
                            const pdfWindow = window.open(URL.createObjectURL(new Blob([respuesta.data], {type: 'application/pdf'})), '_blank').print();
                          })
                           .catch(excepcion => {
                             console.log(excepcion);
                             this.Folios = [];
                            this.IdEquis = [];
                            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                         })
                  }
                  comun.SeEstaCargandoInformacion(false);
                  this.Pausa(2000);//Esperamos a que termine de construir el PDF
                  this.GetFolios(false);
                }
              })
              .catch(excepcion => {
                console.log(excepcion);
                this.Folios = [];
                this.IdEquis = [];
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
              })
        }
      }
      },
      Pausa(ms){
        return new Promise(resolve => setTimeout(resolve, ms));          
      },
      GetFolios(mostrarMensaje){
        this.sinDgitalizar = false;
        comun.SeEstaCargandoInformacion(true);
        this.ObtenerFechaInicial_Final();
        this.ObtenerHoraInicial_Final();
        let peticion = {
          PendientesEnvio: this.PendientesEnvio,
          Recibidos: this.DocsRecibidos,
          Enviados: this.DocumentosEnviados,
          NumeroEnvio: this.numEnvConsultas,
          Digitalizados: this.Digitalizados,
          IdDigitalizador: 0,
          Zona: this.NombreZona,
          AreaRecepcion: 32,//nunca cambiará, al menos no apuntando a EQUITAS n_u
          FechaInicial: this.tab == 1 ? this.FechaIE:(this.tab == 2 ? this.FechaIC: (this.tab == 4 ? this.FechaIM: null)),
          FechaFinal: this.tab == 1 ? this.FechaFE:(this.tab == 2 ? this.FechaFC: (this.tab == 3 ? this.FechaFD: null)),
          IdTipoDocumento: this.TipoDoc,
          IdAreaDestino: this.parametros_AreaPromocion.areaPromoId,
          HoraInicial: this.HoraIni,
          HoraFinal: this.HoraFin,
          ExcluirDemCivCon: this.tab == 1 ? this.DemCivCont : this.excluirCivContCons,
          ExcluirPromCon: this.tab == 1 ? this.PromSala : this.excluirSalaCons,
          ExcluirCivMer: this.tab == 1 ? this.excCivCont : this.excluirCivMerCons,
          PorNombreZona: this.porNombreZona,
          PorEnvioZona: this.porEnvioZona,
          PorTiempoZona: this.porTiempoZona,
          IdDigitalizador: this.IdUsuarioD,
          IdRecepcionista: this.IdUsuarioE,
          AreaFiltro: this.AreaFiltro,
        }
        axios.post(api.conexion + api.TemisCivil.sistema.Oficialia.TraePendientes, peticion).then(response => {
          this.Folios = [];
          this.LimpiarTablas();
          this.Folios = response.data.InfoRegistros;
          this.Folios.forEach(rn => this.IdEquis.push(rn.IdEqui));
          //this.Folios.forEach(nf => this.ColoresDistintos(nf));
          this.LlenarTablaBS();
          if(this.tab == 1)
            document.getElementById('numRegE').innerText = this.Folios.length + "  registros encontrados.";
          else if(this.tab == 2)
            document.getElementById('numRegC').innerText = this.Folios.length + "  registros encontrados.";
          else if(this.tab == 3)
            document.getElementById('numRegD').innerText = this.Folios.length + "  registros encontrados.";
          comun.SeEstaCargandoInformacion(false);
          if(this.Folios.length > 0 && !this.DocumentosEnviados)
            document.getElementById('div_OpcionesEnvio').style.visibility = 'visible';
          else
          {
            document.getElementById('div_OpcionesEnvio').style.visibility = 'hidden';
            if(this.Folios.length <= 0 && mostrarMensaje)
              comun.mensajeDeAlerta("No se encontraron folios que cumplan con los filtros aplicados", null, null);
          }
          if((this.sinDgitalizar && !this.DocumentosEnviados) && mostrarMensaje)
            comun.mensajeDeAlerta("Hay Documentos sin digitalizar, revise las opciones de envío", null, null);
         }).catch(e => {
           console.log(e);
           comun.SeEstaCargandoInformacion(false);
         });
      },
      created() {
        document.getElementById('fechaFinalE').value = hoyFormatoDT;
        document.getElementById('fechaInicialE').value = hoyFormatoDT;
      }
    }
  }
</script>

<style scoped>

  h3 {
    font-size: 18px;
    border-bottom: 2px solid #FFF;
    padding-bottom: 8px;
    margin-bottom: 12px;
  }

  table {
    color: #343a40 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/TemisCivil/OficialiaDePartes/Reportes.vue